import { createContext, useEffect, useState } from "react";
import { spanishPreferred } from "@/js/utils/spanishPreferred";

export const LocalePreferenceContext = createContext({
  prefersSpanish: false,
});

export const withLocalePreference = ({ App }) => {
  const LocalePreferenceProviderHOC = (props) => {
    const [prefersSpanish, setPrefersSpanish] = useState(false);

    useEffect(() => {
      setPrefersSpanish(spanishPreferred());
    }, []);

    return (
      <LocalePreferenceContext.Provider value={{ prefersSpanish }}>
        <App {...props} />
      </LocalePreferenceContext.Provider>
    );
  };

  return LocalePreferenceProviderHOC;
};

export default withLocalePreference;
